import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/documentNode';
import * as Apollo from '@apollo/client';
import process from 'process';
export type BoardSwitcherWorkspaceFragment = (
  { __typename: 'Organization' }
  & Pick<Types.Organization, 'id' | 'displayName' | 'idEnterprise' | 'name' | 'offering'>
);

export const BoardSwitcherWorkspaceFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BoardSwitcherWorkspace' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Organization' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'idEnterprise' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'offering' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseBoardSwitcherWorkspaceFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<
      BoardSwitcherWorkspaceFragment,
      Apollo.OperationVariables
    >,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseBoardSwitcherWorkspaceFragmentResult
  extends Omit<
    Apollo.UseFragmentResult<BoardSwitcherWorkspaceFragment>,
    'data'
  > {
  data?: BoardSwitcherWorkspaceFragment;
}

export const useBoardSwitcherWorkspaceFragment = ({
  from,
  returnPartialData,
  ...options
}: UseBoardSwitcherWorkspaceFragmentOptions): UseBoardSwitcherWorkspaceFragmentResult => {
  const result = Apollo.useFragment<BoardSwitcherWorkspaceFragment>({
    ...options,
    fragment: BoardSwitcherWorkspaceFragmentDoc,
    fragmentName: 'BoardSwitcherWorkspace',
    from: {
      __typename: 'Organization',
      ...from,
    },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('Fragment data is incomplete.', result);
    }
    return {
      ...result,
      data: undefined,
    };
  }

  return { ...result, data: result.data as BoardSwitcherWorkspaceFragment };
};
